import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Send, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export function TomorrowArrivals({ items, template }) {
  const [sent, setSent] = useState({});
  const send = async (b) => {
    const w = window.open("", "_blank");
    try {
      const { data } = await api.get(`/bookings/${b.id}/templates/${template.id}`, { params: { mark: true } });
      const url = `https://wa.me/${b.phone.replace(/^\+/, "")}?text=${encodeURIComponent(data.text)}`;
      if (w) w.location.href = url;
      else window.location.href = url;
      setSent((s) => ({ ...s, [b.id]: true }));
    } catch (e) {
      if (w) w.close();
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="rounded-2xl border bg-white p-5" data-testid="tomorrow-arrivals">
      <h3 className="font-display text-lg font-bold">Arrivi di domani · istruzioni</h3>
      {!template && <p className="text-sm text-stone-500 mt-1">Nessun messaggio impostato come istruzioni d'arrivo: crealo in <Link to="/impostazioni?tab=messaggi" className="text-primary underline">Impostazioni → Messaggi</Link>.</p>}
      {items.length === 0 ? <p className="text-sm text-stone-500 mt-3">Nessun arrivo domani</p> : (
        <ul className="divide-y mt-2">
          {items.map((b) => {
            const done = sent[b.id] || b.arrival_msg_sent_at;
            return (
              <li key={b.id} className="flex flex-wrap items-center justify-between gap-2 py-3" data-testid={`tomorrow-item-${b.id}`}>
                <Link to={`/prenotazioni/${b.id}`} className="min-w-0 hover:text-primary">
                  <p className="font-semibold truncate">{b.ref_name || "Senza nome"}</p>
                  <p className="text-xs text-stone-500">{b.room_name} · lingua {(b.lang || "it").toUpperCase()}</p>
                </Link>
                <div className="flex items-center gap-3">
                {done && <span className="flex items-center gap-1 text-xs text-emerald-700" data-testid={`tomorrow-sent-${b.id}`}><CheckCircle2 className="h-4 w-4" />Inviate</span>}
                {template && b.phone ? (
                  <button type="button" onClick={() => send(b)} className="flex items-center gap-1 rounded-full bg-emerald-600 px-3 py-1 text-xs font-semibold text-white hover:bg-emerald-700" data-testid={`tomorrow-send-${b.id}`}>
                    <Send className="h-3.5 w-3.5" />{done ? "Invia di nuovo" : "Invia istruzioni"}
                  </button>
                ) : !b.phone && <Link to="/prenotazioni" className="text-xs text-amber-700 underline" data-testid={`tomorrow-nophone-${b.id}`}>Manca il telefono</Link>}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
